<template>
  <div class="relative">
    <router-link
      v-if="route.routeType === 'internal'"
      :to="route.link"
      class="flex h-full items-center justify-center px-10 font-semibold text-white hover:bg-primary-700"
      :class="{
        '!bg-primary-400': isActive,
      }"
    >
      {{ route.title }}
    </router-link>

    <a
      v-else-if="route.routeType === 'external'"
      :href="route.link"
      target="_blank"
      class="flex h-full items-center justify-center px-10 font-semibold text-white hover:bg-primary-700"
      :class="{
        '!bg-primary-400': isActive,
      }"
    >
      {{ route.title }}
    </a>

    <!-- notch -->
    <div
      class="absolute left-1/2 size-0 -translate-x-1/2 border-x-8 border-t-8 border-x-transparent border-t-primary-400"
      :class="{
        hidden: !isActive,
      }"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { RouteConfig } from '@/common';
import { RouterLink } from 'vue-router';
defineProps<{
  route: RouteConfig;
  isActive: boolean;
}>();
</script>
